/**
 * Global Styles - App
 *
 * Any global styles overrides or additional styles can be included in this file
 */
import React from 'react';
import {
  createGlobalStyle,
  Normalize,
  thd,
  th,
  up,
  css,
} from '@smooth-ui/core-sc';
import loriGlobalStyles from '_platform/src/theme/globalStyles';

export const GlobalStylesApp = createGlobalStyle`
  ${loriGlobalStyles}

  @import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;700&display=swap');

  @import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

  /* Custom CSS here */

  body {
    font-family: "Poppins", sans-serif;
    line-height: 1.6;
    color: ${th('text')};
  }

  html body .page-wrapper {
    button, .sui-button, .sui-btn, a.sui-button, a.sui-btn, .reward-category-name, .rewards-list-item-button {
    background-color: #fff !important;
    border: 1px solid ${thd('primary', '#867455')} !important;
    border-radius: 4px !important;
    color: ${thd('primary', '#867455')} !important;
    font-weight: bold !important;
    text-transform: uppercase !important;

    &:hover,
    &:focus {
      color: #fff !important;
      background-color: ${thd('primary', '#867455')} !important;
      }
    }

    button[type='submit'].inverse {
      background-color: ${th('primary')} !important;
      border: 2px solid white !important;
      color: white !important;
      &:hover,
      &:focus {
        background-color: ${th('secondary')} !important;
      }
    }

    .sui-input, textarea {
      background-color: #FAFAFA;
      border: 1px solid #E5E5E5;
      border-radius: 5px;
    }

  }

  .page-container {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  h1, h2, h3, .h1, .h2, .h3 {
  font-weight: bold;
  line-height: 1;
}

  h1,.h1 {
    font-size: 40px;
    margin-bottom: .25em;
  text-transform: uppercase;
    ${up(
      'sm',
      css`
        font-size: 60px;
      `
    )}
  }

  h2,.h2 {
    font-size: 30px;
  }

  h3,.h3 {
    font-size: 25px;
  }

  a {
    color: ${thd('defaultLinkColor', 'theme.gray800')};
    &:hover,&:focus {
      text-decoration: none;
    }
  }

  /* Don't wrap emails, phones or other non-wrapping strings */
  .nowrap,
  .date,
  .email,
  .phone {
    white-space: nowrap;
  }

  /* Color text */
  .text--red {
    color: ${thd('danger', '#dc3545')};
  }

  .text--white {
    color: #fff;
  }

  .text--primary {
    color: ${thd('primary', '#867455')};
  }

  /* Align text */
  .text-center,
  .text-centre,
  .text--center,
  .text--centre {
    text-align: center;
  }
  .text-right,
  .text--right {
    text-align: right;
  }
  .text-left,
  .text--left {
    text-align: left;
  }

  .text-small,
  .text--small {
    font-size: 80%;
  }

  .text-large,
  .text--large {
    font-size: 120%;
  }

  .text-larger,
  .text--larger {
    font-size: 200%;
  }

  .text-normal,
  .text--normal {
    font-weight: normal;
  }
  .text-uppercase,
  .text--uppercase {
    text-transform: uppercase;
  }

  .text--tight {
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
  }

  /* Handy spacing classes */
  :root {
    --spacer: 2rem;
  }

  .spacer {
    padding-bottom: 40px;
    padding-top: 40px;
    padding-bottom: var(--spacer);
    padding-top: var(--spacer);
  }
  .spacer--small {
    padding-bottom: 20px;
    padding-top: 20px;
    padding-bottom: calc(var(--spacer) / 2);
    padding-top: calc(var(--spacer) / 2);
  }
  .spacer--large {
    padding-bottom: 80px;
    padding-top: 80px;
    padding-bottom: calc(var(--spacer) * 2);
    padding-top: calc(var(--spacer) * 2);
  }
  .spacer--around {
    padding: 40px;
    padding: var(--spacer);
  }
  .spacer--around--small {
    padding: 20px;
    padding: calc(var(--spacer) / 2);
  }
  .spacer--around--large {
    padding: 80px;
    padding: calc(var(--spacer) * 2);
  }
  .spacer--top {
    padding-top: 40px;
    padding-top: var(--spacer);
  }
  .spacer--bottom {
    padding-bottom: 40px;
    padding-bottom: var(--spacer);
  }
  .spacer--top--small,
  .spacer--small--top {
    padding-top: 20px;
    padding-top: calc(var(--spacer) / 2);
  }
  .spacer--bottom--small,
  .spacer--small--bottom {
    padding-bottom: 20px;
    padding-bottom: calc(var(--spacer) / 2);
  }
  .spacer--top--large,
  .spacer--large--top {
    padding-top: 80px;
    padding-top: calc(var(--spacer) * 2);
  }
  .spacer--bottom--large,
  .spacer--large--bottom {
    padding-bottom: 80px;
    padding-bottom: calc(var(--spacer) * 2);
  }

  .Toastify .Toastify__toast--success {
    background: #07bc0c;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    border: 0;
  }

  label {
    font-weight: bold;
  }

  hr {
    border-top: 1px solid ${th('primary')};
  }

`;

const StylesApp = () => (
  <React.Fragment>
    <Normalize />
    <GlobalStylesApp />
  </React.Fragment>
);

export default StylesApp;
